<h1 style="font-family: 'Open Sans'; font-weight: 800">Games</h1>
<div fxLayout="row" fxLayoutGap="50px">
  <app-game-card
    *ngFor="let game of games"
    [content]="game">
  </app-game-card>
</div>